module.exports = __webpack_public_path__ + "static/01-f700ac993ddd647e6f74178fab51b395.jpg";